import { render, staticRenderFns } from "./foodmanagement.vue?vue&type=template&id=16f37411&"
import script from "./foodmanagement.vue?vue&type=script&lang=js&"
export * from "./foodmanagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports